export default "__VITE_ASSET__318fa4d0__"